import { createSlice } from "@reduxjs/toolkit";
import PatolojiRaporKurtarRequest from "src/models/PatolojiModul/PatolojiRaporKurtarRequest";
import PatolojiRaporKurtarYenileRequest from "src/models/PatolojiModul/PatolojiRaporKurtarYenileRequest";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

interface IPatolojiRaporKurtar {
    aramaKriterleri: PatolojiRaporKurtarRequest;
    handlerSearch: boolean;
    open: boolean;
    activeRow: PatolojiRaporKurtarYenileRequest;
};
export const PatolojiRaporKurtarSlice = createSlice<IPatolojiRaporKurtar, MapReducerPayloads<IPatolojiRaporKurtar, {
    setAramaKriterleri: PatolojiRaporKurtarRequest;
    setHandlerSearch: boolean;
    setOpen: boolean;
    setActiveRow: PatolojiRaporKurtarYenileRequest;
}>>({
    name: "patolojiRaporKurtar",
    initialState: {
        aramaKriterleri: new PatolojiRaporKurtarRequest(),
        handlerSearch: true,
        open: false,
        activeRow: new PatolojiRaporKurtarYenileRequest(),
    },
    reducers: {
        setAramaKriterleri: (state, action) => {
            state.aramaKriterleri = action.payload;
        },
        setHandlerSearch: (state, action) => {
            state.handlerSearch = action.payload;
        },
        setOpen: (state, action) => {
            state.open = action.payload
        },
        setActiveRow: (state, action) => {
            state.activeRow = action.payload
        },
    },
});